import { B as oe } from "./BadgeGraySm-db599b39.js";
import { openBlock as c, createElementBlock as s, renderSlot as t } from "vue";
import { _ as n } from "./_plugin-vue_export-helper-dad06003.js";
import { a as ge, B as fe } from "./BadgePurpleSm-624c687b.js";
import { B as $e } from "./BadgeStatusSm-03be1252.js";
const a = {}, d = { class: "ct-badge-gray ct-badge-md" };
function o(e, r) {
  return c(), s("p", d, [
    t(e.$slots, "default")
  ]);
}
const R = /* @__PURE__ */ n(a, [["render", o]]), _ = {}, g = { class: "ct-badge-gray ct-badge-lg" };
function f(e, r) {
  return c(), s("p", g, [
    t(e.$slots, "default")
  ]);
}
const T = /* @__PURE__ */ n(_, [["render", f]]), i = {}, $ = { class: "ct-badge-error ct-badge-sm" };
function l(e, r) {
  return c(), s("p", $, [
    t(e.$slots, "default")
  ]);
}
const U = /* @__PURE__ */ n(i, [["render", l]]), u = {}, m = { class: "ct-badge-error ct-badge-md" };
function b(e, r) {
  return c(), s("p", m, [
    t(e.$slots, "default")
  ]);
}
const V = /* @__PURE__ */ n(u, [["render", b]]), h = {}, p = { class: "ct-badge-error ct-badge-lg" };
function B(e, r) {
  return c(), s("p", p, [
    t(e.$slots, "default")
  ]);
}
const X = /* @__PURE__ */ n(h, [["render", B]]), S = {}, x = { class: "ct-badge-warning ct-badge-sm" };
function y(e, r) {
  return c(), s("p", x, [
    t(e.$slots, "default")
  ]);
}
const Y = /* @__PURE__ */ n(S, [["render", y]]), k = {}, E = { class: "ct-badge-warning ct-badge-md" };
function L(e, r) {
  return c(), s("p", E, [
    t(e.$slots, "default")
  ]);
}
const Z = /* @__PURE__ */ n(k, [["render", L]]), M = {}, w = { class: "ct-badge-warning ct-badge-lg" };
function G(e, r) {
  return c(), s("p", w, [
    t(e.$slots, "default")
  ]);
}
const ee = /* @__PURE__ */ n(M, [["render", G]]), W = {}, P = { class: "ct-badge-success ct-badge-md" };
function I(e, r) {
  return c(), s("p", P, [
    t(e.$slots, "default")
  ]);
}
const ce = /* @__PURE__ */ n(W, [["render", I]]), O = {}, j = { class: "ct-badge-success ct-badge-lg" };
function q(e, r) {
  return c(), s("p", j, [
    t(e.$slots, "default")
  ]);
}
const se = /* @__PURE__ */ n(O, [["render", q]]), v = {}, z = { class: "ct-badge-orange ct-badge-sm" };
function A(e, r) {
  return c(), s("p", z, [
    t(e.$slots, "default")
  ]);
}
const te = /* @__PURE__ */ n(v, [["render", A]]), C = {}, D = { class: "ct-badge-pink ct-badge-sm" };
function F(e, r) {
  return c(), s("p", D, [
    t(e.$slots, "default")
  ]);
}
const ne = /* @__PURE__ */ n(C, [["render", F]]), H = {}, J = { class: "ct-badge-indigo ct-badge-sm" };
function K(e, r) {
  return c(), s("p", J, [
    t(e.$slots, "default")
  ]);
}
const re = /* @__PURE__ */ n(H, [["render", K]]);
export {
  X as BadgeErrorLg,
  V as BadgeErrorMd,
  U as BadgeErrorSm,
  T as BadgeGrayLg,
  R as BadgeGrayMd,
  oe as BadgeGraySm,
  re as BadgeIndigoSm,
  te as BadgeOrangeSm,
  ne as BadgePinkSm,
  ge as BadgePurpleSm,
  $e as BadgeStatusSm,
  se as BadgeSuccessLg,
  ce as BadgeSuccessMd,
  fe as BadgeSuccessSm,
  ee as BadgeWarningLg,
  Z as BadgeWarningMd,
  Y as BadgeWarningSm
};
